"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberInputSchema = exports.default = void 0;
var PhoneNumberInput_1 = require("./PhoneNumberInput");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(PhoneNumberInput_1).default; } });
Object.defineProperty(exports, "PhoneNumberInputSchema", { enumerable: true, get: function () { return PhoneNumberInput_1.PhoneNumberInputSchema; } });
//# sourceMappingURL=index.js.map